import { Zap, FileSpreadsheet, Map as MapIcon, Database } from "lucide-react";

const tools = [
  {
    title: "Valorización Comercial Precisa",
    description: "Obtén en segundos el valor comercial gracias a nuestro algoritmo de machine learning.",
    icon: Zap
  },
  {
    title: "Informe de Tasación IA",
    description: "Genera un informe profesional apoyado por IA que automatiza análisis comerciales complejos.",
    icon: FileSpreadsheet
  },
  {
    title: "Antecedentes de Propiedades",
    description: "Obtén instantáneamente nombre de propietario, avalúo fiscal, deudas y transacciones anteriores.",
    icon: Database
  },
  {
    title: "Mapa Inmobiliario",
    description: "Explora georeferencialmente el detalle de transacciones históricas y oferta actual.",
    icon: MapIcon
  }
];

export function ValuationTools() {
  return (
    <section className="py-32 bg-parchment relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center text-center mb-24">
          <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-6 block">Inteligencia de Mercado</span>
          <h2 className="text-5xl md:text-8xl font-display font-black uppercase text-ink leading-none mb-8 italic">
            Valoriza Rápido <br /> y con Precisión
          </h2>
          <p className="text-xl font-serif italic text-ink/60 max-w-2xl">
            Accede al instante a la información más relevante del mercado inmobiliario y genera informes de tasación personalizables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {tools.map((tool, idx) => (
            <div key={idx} className="flex gap-8 group">
              <div className="flex-shrink-0 w-20 h-20 bg-ink flex items-center justify-center text-terracotta group-hover:bg-terracotta group-hover:text-parchment transition-colors brutalist-border">
                <tool.icon className="h-10 w-10" />
              </div>
              <div>
                <h3 className="text-2xl font-display font-black uppercase mb-4 text-ink italic">{tool.title}</h3>
                <p className="text-lg font-serif italic text-ink/70 leading-relaxed">
                  {tool.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-24 p-12 bg-ink text-parchment brutalist-border relative">
          <div className="absolute top-0 right-0 p-4 opacity-10">
            <Database className="h-32 w-32" />
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
            <div>
              <h4 className="text-3xl font-display font-black uppercase mb-6 italic">Cobertura Nacional Total</h4>
              <p className="font-serif italic text-parchment/60 text-lg mb-8">
                Nuestro algoritmo de IA tiene cobertura en todo Chile para casas, departamentos, terrenos, oficinas, locales, bodegas y estacionamientos.
              </p>
              <ul className="grid grid-cols-2 gap-4">
                {['Valor de mercado', 'Evolutivo UF/M2', 'Tiempo colocación', 'Competitividad'].map((item, i) => (
                  <li key={i} className="flex items-center gap-2 text-xs font-black uppercase tracking-widest text-terracotta">
                    <span className="w-2 h-2 bg-terracotta" /> {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="grayscale opacity-50 hover:grayscale-0 hover:opacity-100 transition-all cursor-pointer">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80" 
                alt="Market Data" 
                className="w-full h-64 object-cover border-2 border-parchment/20"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
